export enum TournamentStatus2 {
    Hidden = 0, // the tournament is not visible at all
    Announced = 1, // visible in the lobby but cannot register yet
    RegistrationOpen = 2, // you can register, tournament not started
    RunningWithLateRegistration = 3, // tournament running with late registration still accepted
    RunningRegistrationClosed = 4, // tournament running, can no longer register
    Completed = 5, // tournament is over
    Canceled = 6, // has been canceled (not enought players registered)
}
